const labelFragmentShader = `
    uniform vec3 u_labelColor;
    void main() {
        gl_FragColor = vec4(u_labelColor, 1.);
    }
`;

export default labelFragmentShader;
